import axios from 'axios';
import router from '../router'
import Vue from 'vue'


var imgServerUrl = process.env.IMG_BASE_URL;
axios.defaults.baseURL = process.env.API_URL;


axios.interceptors.request.use(function (config) {
    var ls = window.sessionStorage.getItem('jwt-token');
    config.headers['Jwt-Token'] = ls;
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    if (response.data.Code === 403) {

        if (response.request.responseURL.indexOf('Common/RoleOption') < 0) {
            Vue.prototype.$message.error(response.data.Msg);
        }


        router.replace({
            path: 'login',
            query: { redirect: router.currentRoute.fullPath }
        })
    } else if (response.data.Code !== 1) {
        Vue.prototype.$message.error(response.data.Msg);
    }

    return response;
}, function (error) {
    return Promise.reject(error);
});

export const getBaseUrl = params => {
    return axios.defaults.baseURL;
};

export const imgServerHost = params => {
    return imgServerUrl;
};

export const requestLogin = params => {
    var result = axios.post(`/api/Auth/SignIn`, params);
    return result;
};

export const editPassword = params => {
    var result = axios.post(`/api/Auth/EditPassword`, params);
    return result;
};

export const getUserDictOption = params => {
    var result = axios.get(`/api/Common/UserDictOption?key=` + params, {});
    return result;
};

export const getUsers = params => {
    var result = axios.post(`/api/User/Users`, params);
    return result;
};

export const exportUsersMainInfo = params => {
    var result = axios.post(`/api/User/ExportUsersMainInfo`, params);
    return result;
};

export const ExportLearnersMainInfo = params => {
    var result = axios.post(`/api/User/ExportLearnersMainInfo`, params);
    return result;
};

export const UserTagsExport = params => {
    var result = axios.post(`/api/User/UserTagsExport`, params);
    return result;
};

export const ImportUsers = params => {
    var result = axios.post('/api/User/ImportUsers', params);
    return result;
}

export const ImportUsersNew = params => {
    var result = axios.post('/api/User/ImportUsersNew', params);
    return result;
}

export const getProducts = params => {
    var result = axios.post(`/api/Product/Products`, params);
    return result;
};

export const productTree = params => {
    var result = axios.post(`/api/Product/ProductTree`, params);
    return result;
};

export const getCustomers = params => {
    var result = axios.post(`/api/Customer/Customers`, params);
    return result;
};

export const authCustomers = params => {
    var result = axios.post(`/api/Customer/AuthCustomer`, params);
    return result;
};

export const exportCustomerMainInfo = params => {
    var result = axios.post(`/api/Customer/ExportCustomerMainInfo`, params);
    return result;
};

export const exportNoVisitCustomerInfo = params => {
    var result = axios.post(`/api/Customer/ExportNoVisitCustomerInfo`, params);
    return result;
};

export const getEditedCustomers = params => {
    var result = axios.post(`/api/Customer/EditedCustomers`, params);
    return result;
};

export const downLoadCustomerTemplate = params => {
    var result = axios.post(`/api/Customer/DownLoadCustomerTemplate`, params);
    return result;
};

export const getRoleOption = params => {
    var result = axios.get(`/api/Common/RoleOption?addAll=` + params, {});
    return result;
};

export const GetEventOption = params => {
    var result = axios.get(`/api/Common/EventOption?addAll=` + params, {});
    return result;
};



export const getLearnerRoleOption = params => {
    var result = axios.get(`/api/Common/LearnerRoleOption?addAll=` + params, {});
    return result;
};

export const getDomainOption = params => {
    var result = axios.get(`/api/Common/DomainOption?addAll=` + params, {});
    return result;
};

export const getUserRegionCascaderOption = params => {
    var result = axios.get(`/api/Common/AllUserRegionCascaderOption?pid=` + params, {});
    return result;
};

export const getRegionCascaderOption = params => {
    var result = axios.get(`/api/Common/AllRegionCascaderOption?pid=` + params, {});
    return result;
};

export const getUserCascaderOption = params => {
    var result = axios.get(`/api/Common/AllUserCascaderOption?pid=${params}&addAll=false`, {});
    return result;
};

export const getUserMultiCascaderOption = params => {
    if (params == null) params = false;
    var result = axios.get(`/api/Common/AllUserMultiCascaderOption?pid=null&addAll=` + params, {});
    return result;
};

export const getTemplateIdOption = params => {
    if (params == null) params = false;
    var result = axios.get(`/api/Common/TemplateIdOption`, {});
    return result;
};

export const unBindLock = params => {
    var result = axios.post(`/api/User/UnBindLock?userId=` + params, {});
    return result;
};

export const resetAvatar = params => {
    var result = axios.post(`/api/User/ResetAvatar?userId=` + params, {});
    return result;
};

export const unBindIEMI = params => {
    var result = axios.post(`/api/User/UnBindIEMI?userId=` + params, {});
    return result;
};

export const resetPssword = params => {
    var result = axios.post(`/api/User/ResetPssword`, { UserId: params });
    return result;
};

export const editUser = params => {
    var result = axios.post(`/api/User/CreateOrUpdate`, params);
    return result;
};

export const exportUsers = params => {
    var result = axios.get(`/api/User/ExportUsers`, params);
    return result;
};

export const chainstoreOption = params => {
    var result = axios.get(`/api/Common/ChainstoreOption`, params);
    return result;
};
//主数据下拉列表接口集合
export const subChannelOption = params => {
    var result = axios.get(`/api/Common/ChannelOption`, params);
    return result;
};

export const subChannelOptionaddAll = params => {
    var result = axios.get(`/api/Common/ChannelOption?addAll=true`, params);
    return result;
};

export const subLv1ChannelOption = params => {
    var result = axios.get(`/api/Common/Lv1ChannelOption`, params);
    return result;
};

export const subLv2ChannelOption = params => {
    var result = axios.post(`/api/Common/Lv2ChannelOption`, params);
    return result;
};

export const subLv1TaskOption = params => {
    var result = axios.get(`/api/Common/Lv1TaskOption`, params);
    return result;
};

export const subLv2TaskOption = params => {
    var result = axios.post(`/api/Common/Lv2TaskOption`, params);
    return result;
};
export const subCityOption = params => {
    var result = axios.post(`/api/Common/CityOption`, params);
    return result;
};
export const subRegionOption = params => {
    var result = axios.post(`/api/Common/RegionOption`, params);
    return result;
};
export const subRegionLv2Option = params => {
    var result = axios.post(`/api/Common/Lv2RegionOption`, params);
    return result;
};
export const GetDictValue = params => {
    var result = axios.post(`/api/Common/GetDictValue`, params);
    return result;
};

export const getDistriburtors = params => {
    var result = axios.post(`/api/Distributor/GetDistriburtors`, params);
    return result;
};

export const GetDictChain = params => {
    var result = axios.post(`/api/Customer/GetDictChain`, params);
    return result;
};

export const GetDictChainLv2 = params => {
    var result = axios.post(`/api/Customer/GetDictChainLv2`, params);
    return result;
};
//门店审批接口集合

export const deleteCustomerApply = params => {
    var result = axios.post(`/api/Customer/DeleteCustomerApply`, params);
    return result;
};

export const jobtaskOption = params => {
    var result = axios.get(`/api/Common/JobTaskOption`, params);
    return result;
};
export const templateOption = params => {
    //var result = axios.get(`/api/Common/TemplateOption`, params);
    var result = axios.post(`/api/Common/TemplateOption`, params);
    return result;
};

export const importCustomers = params => {
    var result = axios.post(`/api/Customer/ImportCustomer`, params);
    return result;
};

export const getManagerCallReport = params => {
    var result = axios.post(`/api/NCallCard/GetManagerCallReport`, params);
    return result;
};

export const getCallCardPhoto = params => {
    var result = axios.post(`/api/CallCard/GetCallCardPhoto`, params);
    return result;
};

export const getCallCardPhotoRar = params => {
    var result = axios.post(`/api/CallCard/GetCallCardPhotoRar`, params);
    return result;
};

export const getCallCardPhotoExcel = params => {
    var result = axios.post(`/api/CallCard/GetCallCardPhotoExcel`, params);
    return result;
};

export const getCallCardDetail = params => {
    var result = axios.post(`/api/NCallCard/GetCallCardDetail`, params);
    return result;
};

export const getCallCardDetails = params => {
    var result = axios.post(`/api/NCallCard/GetDetailWithValues?callCardId=` + params.CallCardID + '&brand=' + params.Brand, {});
    return result;
};

export const getRoutePlanDetails = params => {
    var result = axios.post(`/api/NRoutePlan/GetRoutePlanDetails?userId=` + params.userId + '&month=' + params.month, {});
    return result;
};

export const importProducts = params => {
    var result = axios.post(`/api/Product/ImportProducts`, params);
    return result;
};

export const message = params => {
    var result = axios.post(`/api/NMessage/Message`, params);
    return result;
};

export const messageSend = params => {
    var result = axios.post(`/api/NMessage/Send`, params);
    return result;
};

export const getMessageList = params => {
    var result = axios.get(`/api/NMessage/GetMessageList?pageSize=` + params.pageSize + '&page=' + params.page + '&uid=' + params.uid + '&group=' + params.group, {});
    return result;
};

export const getMessageDetail = params => {
    var result = axios.get(`/api/NMessage/GetMessageDetail?pid=` + params.pid + '&uid=' + params.uid, {});
    return result;
};

export const getMessagebackDetail = params => {
    var result = axios.get(`/api/NMessage/GetMessageBackDetail?callCardId=` + params.CallCardId + '&userId=' + params.UserId, {});
    return result;
};

export const SendReply = (params, distUserId) => {
    var result = axios.post(`/api/NMessage/SendReply?userId=` + distUserId + '&msgId=' + params.MsgId + "&txt=" + params.Txt, {});
    return result;
};

export const SearchAtomConfig = (params) => {
    var result = axios.post(`/api/ConfigCenter/SearchAtomConfig`, params);
    return result;
};

export const DelAtomConfig = (param) => {
    var result = axios.post(`/api/ConfigCenter/DelAtomConfig` + `?configId=` + param, null);
    return result;
};


export const SearchWorkRole = (params) => {
    var result = axios.post(`/api/ConfigCenter/SearchWorkRole`, params);
    return result;
};

export const AddWorkRole = (params) => {
    var result = axios.post(`/api/ConfigCenter/AddWorkRole`, params);
    return result;
};

export const EditWorkRole = (params) => {
    var result = axios.post(`/api/ConfigCenter/EditWorkRole`, params);
    return result;
};

export const DelWorkRole = (param) => {
    var result = axios.post(`/api/ConfigCenter/DelWorkRole` + `?wid=` + param, null);
    return result;
};

export const SearchPermission = (params) => {
    var result = axios.post(`/api/ConfigCenter/SearchPermission`, params);
    return result;
};

export const AddPermission = (params) => {
    var result = axios.post(`/api/ConfigCenter/AddPermission`, params);
    return result;
};

export const EditPermission = (params) => {
    var result = axios.post(`/api/ConfigCenter/EditPermission`, params);
    return result;
};

export const DelPermission = (param) => {
    var result = axios.post(`/api/ConfigCenter/DelPermission` + `?pid=` + param, null);
    return result;
};

export const AddAtomConfig = (params) => {
    var result = axios.post(`/api/ConfigCenter/AddAtomConfig`, params);
    return result;
};

export const EditAtomConfig = (params) => {
    var result = axios.post(`/api/ConfigCenter/EditAtomConfig`, params);
    return result;
};


export const SearchDict = (params) => {
    var result = axios.post(`/api/ConfigCenter/SearchDict`, params);
    return result;
};

export const AddDict = (params) => {
    var result = axios.post(`/api/ConfigCenter/AddDict`, params);
    return result;
};

export const EditDict = (params) => {
    var result = axios.post(`/api/ConfigCenter/EditDict`, params);
    return result;
};

export const DelDict = (param) => {
    var result = axios.post(`/api/ConfigCenter/DelDict` + `?cid=` + param, null);
    return result;
};

export const SetRolePermissions = (params) => {
    var result = axios.post(`/api/ConfigCenter/SetRolePermissions`, params);
    return result;
};

export const GetAppVersion = (params) => {
    var result = axios.get(`/api/ConfigCenter/GetAppVersion`, params);
    return result;
};

export const DeployAndroid = (params) => {
    var result = axios.post(`/api/ConfigCenter/DeployAndroid`, params);
    return result;
};

export const DeployIos = (params) => {
    var result = axios.post(`/api/ConfigCenter/DeployIos`, params);
    return result;
};

export const CityTree = (params) => {
    var result = axios.post(`/api/CityRegion/CityTree`, params);
    return result;
};

export const Cities = (params) => {
    var result = axios.post(`/api/CityRegion/Cities`, params);
    return result;
};
export const ExportCities = (params) => {
    var result = axios.post(`/api/CityRegion/ExportCities`, params);
    return result;
};
// api/CityRegion/GetOrganizationList?level=1 
// 获取部门区域
export const GetCityRegion = (params) => {
    var result = axios.post(`/api/CityRegion/GetOrganizationList`, params);
    return result;
};

export const RegionTree = (params) => {
    var result = axios.post(`/api/CityRegion/RegionTree`, params);
    return result;
};
export const RegionCenterTree = (params) => {
    var result = axios.post(`/api/CityRegion/RegionCenterTree`, params);
    return result;
};
export const Regions = (params) => {
    var result = axios.post(`/api/CityRegion/Regions`, params);
    return result;
};
export const ExportRegions = (params) => {
    var result = axios.post(`/api/CityRegion/ExportRegions`, params);
    return result;
};

export const AddRegion = (params) => {
    var result = axios.post(`/api/CityRegion/AddRegion`, params);
    return result;
};

export const EditRegion = (params) => {
    var result = axios.post(`/api/CityRegion/EditRegion`, params);
    return result;
};

export const DelRegion = (param) => {
    var result = axios.post(`/api/CityRegion/DelRegion` + `?rid=` + param, null);
    return result;
};
// 导出无效、未分配省区
export const ExportRegionList = (params) => {
    var result = axios.post(`/api/CityRegion/ExportErrRegionList`, params);
    return result;
};

export const getChannels = params => {
    var result = axios.post(`/api/Channel/Channels`, params);
    return result;
};

export const TrainCourses = params => {
    var result = axios.post(`/api/TrainProject/TrainCourses`, params);
    return result;
};

export const TrainProjects = params => {
    var result = axios.post(`/api/TrainProject/TrainProjects`, params);
    return result;
};

export const importChannels = params => {
    var result = axios.post(`/api/Channel/ImportChannel`, params);
    return result;
};

export const getDistributors = params => {
    var result = axios.post(`/api/Distributor/Distributors`, params);
    return result;
};

export const importDistributors = params => {
    var result = axios.post(`/api/Distributor/ImportDistributor`, params);
    return result;
};

export const getCbds = params => {
    var result = axios.post(`/api/Cbd/Cbds`, params);
    return result;
};

export const importCbds = params => {
    var result = axios.post(`/api/Cbd/ImportCbd`, params);
    return result;
};

export const jobTasks = params => {
    var result = axios.post(`/api/JobTask/JobTasks`, params);
    return result;
};

export const JobTasksForUser = params => {
    var result = axios.post(`/api/JobTask/JobTasksForUser`, params);
    return result;
};

export const taskTypeOption = params => {
    var result = axios.post(`/api/Common/TaskTypeOption`, params);
    return result;
};

export const taskGroupOption = params => {
    var result = axios.post(`/api/Common/TaskGroupOption`, params);
    return result;
};

export const CreateTask = params => {
    var result = axios.post(`/api/JobTask/CreateTask`, params);
    return result;
};

export const DeployTask = params => {
    var result = axios.post(`/api/JobTask/DeployTask`, params);
    return result;
};


export const ChannelTree = params => {
    var result = axios.post(`/api/Channel/ChannelTree`, params);
    return result;
};

export const ImportRegions = params => {
    var result = axios.post(`/api/CityRegion/ImportRegions`, params);
    return result;
};


export const ProductTags = params => {
    var result = axios.post(`/api/Product/ProductTags`, params);
    return result;
};


export const ProductsFromTags = params => {
    var result = axios.post(`/api/Product/ProductsFromTags`, params);
    return result;
};

export const GetDictsByParentCode = params => {
    var result = axios.post(`/api/Common/GetDictsByParentCode?dictCode=` + params, {});
    return result;
};

export const CustomOption = params => {
    var result = axios.get(`/api/Common/CustomOption?tag=` + params, {});
    return result;
};


export const GetDictsByDomainParentCode = params => {
    var result = axios.post(`/api/Common/GetDictsByDomainParentCode?dictCode=` + params, {});
    return result;
};



export const GetChannelByIds = params => {
    var result = axios.post(`/api/Common/GetChannelByIds?channelIds=` + params, {});
    return result;
};

export const GetDictsByParentCodeAsync = async params => {
    var result = await axios.post(`/api/Common/GetDictsByParentCode?dictCode=` + params, {});
    return result;
};

export const AddTaskDicts = params => {
    var result = axios.post(`/api/ConfigCenter/AddTaskDicts`, params);
    return result;
};

export const getReport1 = params => {
    var result = axios.post(`/api/Report/GetReport1`, params);
    return result;
};
export const getReportList = params => {
    var result = axios.post(`/api/Report/getReportList`, params);
    return result;
};

export const GetWorkLoadReport = params => {
    var result = axios.post(`/api/Report/GetWorkLoadReport`, params);
    return result;
};
export const GetPerformanceReport = params => {
    var result = axios.post(`/api/Report/GetPerformanceReport`, params);
    return result;
};

export const GetToTerminalReport = params => {
    var result = axios.post(`/api/Report/GetToTerminalReport`, params);
    return result;
};
export const GetToTerminalReport_KPI = params => {
    var result = axios.post(`/api/Report/GetToTerminalReport_KPI`, params);
    return result;
};

export const getKPIRegionCascaderOption = params => {
    var result = axios.get(`/api/Report/AllRegionCascaderOption?domainId=` + params, {});
    return result;
};

export const getUserCascaderReport = params => {
    if (params == null) params = false;
    var result = axios.get(`/api/Report/AllUserCascaderOption?userId=` + params, {});
    return result;
};

export const AllCitiesCascaderOption = params => {
    // if (params == null) params = false;
    var result = axios.get(`/api/Common/AllCitiesCascaderOption?pid=` + params, {});
    return result;
};

export const AllCitiesCascaderNoLeavesOption = params => {
    // if (params == null) params = false;
    var result = axios.get(`/api/Common/AllCitiesCascaderNoLeavesOption?pid=` + params, {});
    return result;
};

export const getKPIRoleOption = params => {
    var result = axios.get(`/api/Report/RoleOption?domainId=` + params, {});
    return result;
};

export const getKPIChannelOption = params => {
    var result = axios.get(`/api/Report/Lv1ChannelOption?domainId=` + params, {});
    return result;
};

export const getWorkRoleByUser = params => {
    var result = axios.get(`/api/Report/GetWorkRoleByUser?userId=` + params, {});
    return result;
};

export const GetTableColumns = params => {
    var result = axios.post(`/api/Common/GetTableColumns?tableName=` + params, {});
    return result;
};

export const SetTaskStatus = params => {
    var result = axios.post(`/api/JobTask/SetTaskStatus`, params);
    return result;
};

export const CopyTask = params => {
    var result = axios.post(`/api/JobTask/CopyTask?taskId=${params.taskId}&newName=${params.newName}`, {});
    return result;
};


export const GetTaskById = params => {
    var result = axios.post(`/api/JobTask/GetTaskById?taskId=` + params, {});
    return result;
};

export const GetTempletes = params => {
    var result = axios.post(`/api/JobTask/GetTempletes?taskId=` + params, {});
    return result;
};

export const SetTaskSort = params => {
    var result = axios.post(`/api/JobTask/SetSort?taskId=` + params, {});
    return result;
};

export const CoverTaskSetting = params => {
    var result = axios.post(`/api/JobTask/CoverTaskSetting?fromTaskId=${params.fromTaskId}&toTaskId=${params.toTaskId}`, {});
    return result;
};

export const DelSkuOrTypes = params => {
    var result = axios.post(`/api/Product/DelSkuOrTypes?pid=${params.pid}&isSku=${params.isSku}`, {});
    return result;
};

export const Domains = params => {
    var result = axios.post(`/api/Domain/Domains`, {});
    return result;
};

export const SetSortByGroup = params => {
    var result = axios.post(`/api/JobTask/SetSortByGroup?taskIds=` + params, {});
    return result;
};

//门店审核接口集合
export const ExportCustomerInfo = params => {
    var result = axios.post(`/api/Customer/ExportCustomerInfo`, params);
    return result;
};

export const GetCallCardBase = params => {
    var result = axios.post(`/api/CallCard/GetCallCardBase?callCardId=${params}`);
    return result;
};

export const GetCallCardModule = params => {
    var result = axios.post(`/api/CallCard/GetCallCardModule?taskId=${params.taskId}&&templateId=${params.templateId}&&callCardId=${params.callCardId}&&itemType=${params.itemType}`);
    return result;
};

export const AddDomain = params => {
    var result = axios.post(`/api/Domain/AddDomain`, params);
    return result;
};


export const GetTaskTags = params => {
    var result = axios.post(`/api/JobTask/GetTaskTags?taskId=${params.JobTaskId}`);
    return result;
};

export const SetTaskTags = params => {
    var result = axios.post(`/api/JobTask/SetTaskTags`, params);
    return result;
};

export const GetAllTaskTags = params => {
    var result = axios.post(`/api/JobTask/GetAllTaskTags`, params);
    return result;
};
export const GetAllTaskGroups = params => {
    var result = axios.post(`/api/JobTask/GetAllTaskGroups`, params);
    return result;
};
export const DelTaskTag = params => {
    var result = axios.post(`/api/JobTask/DelTaskTag?taskTagName=${params}`);
    return result;
};

export const GetTaskNames = params => {
    var result = axios.get(`/api/JobTask/GetTaskNames`);
    return result;
};

export const GetTaskNamesByTags = params => {
    var result = axios.post(`/api/JobTask/GetTaskNamesByTags`, params);
    return result;
};
export const GetTaskNamesByGroupIds = params => {
    var result = axios.post(`/api/JobTask/GetTaskNamesByGroupIds`, params);
    return result;
};

export const GetTaskModules = params => {
    var result = axios.get(`/api/JobTask/GetTaskModules?taskId=${params}`);
    return result;
};

export const GetCopyTaskModulesJson = params => {
    var result = axios.post(`/api/JobTask/GetCopyTaskModulesJson`, params);
    return result;
};

export const GenHtmlFileFromJson = params => {
    var result = axios.post(`/api/JobTask/GenHtmlFileFromJson`, params);
    return result;
};

export const GetPromoteModules = params => {
    var result = axios.post(`/api/JobTask/GetPromoteModules?taskId=${params}`);
    return result;
};

export const AddPromote = params => {
    var result = axios.post(`/api/Promote/AddPromote`, params);
    return result;
};

export const Promotes = params => {
    var result = axios.post(`/api/Promote/Promotes`, params);
    return result;
};

export const PromotesExport = params => {
    var result = axios.post(`/api/Promote/PromotesExport`, params);
    return result;
};

export const GetPromoteTemplateItems = params => {
    var result = axios.post(`/api/JobTask/GetPromoteTemplateItems?templateId=${params}`);
    return result;
};

export const GetLogList = params => {
    var result = axios.post(`/api/Common/GetLogList`, params);
    return result;
};

export const DownLoadUserInErr = params => {
    var result = axios.post(`/api/User/DownLoadUserInErr?batchId=${params}`);
    return result;
};

export const DownLoadLearnerInErr = params => {
    var result = axios.post(`/api/User/DownLoadLearnerInErr?batchId=${params}`);
    return result;
};

export const DelPromote = params => {
    var result = axios.post(`/api/Promote/DelPromote?promoteId=${params}`);
    return result;
};

export const IsHideImportDel = params => {
    var result = axios.post(`/api/JobTask/IsHideImportDel?taskId=${params}`);
    return result;
};

export const DownLoadUserTagInErr = params => {
    var result = axios.post(`/api/User/DownLoadUserTagInErr?batchId=${params}`);
    return result;
};

export const UserTagOption = params => {
    var result = axios.post(`/api/User/UserTagOption`);
    return result;
};

export const GetBLogs = params => {
    var result = axios.post(`/api/JobTask/GetBLogs?taskId=${params}`);
    return result;
};

export const GetCustomerKpi = params => {
    var result = axios.post(`/api/Customer/GetCustomerKpi`, params);
    return result;
};

export const UserMultiSelectOption = params => {
    var result = axios.post(`/api/Common/UserMultiSelectOption?keyWord=${params}`);
    return result;
};

export const DelChannel = params => {
    var result = axios.post(`/api/Channel/DelChannel?channelId=${params}`);
    return result;
};

export const ExportTaskCustomers = params => {
    var result = axios.post(`/api/Customer/ExportTaskCustomers?taskId=${params}`);
    return result;
};

export const ExportTaskUsers = params => {
    var result = axios.post(`/api/User/ExportTaskUsers?taskId=${params}`);
    return result;
};

export const ImportTargetMarkets = params => {
    var result = axios.post(`/api/TaskTarget/ImportTaskTarget`, params);
    return result;
};

export const ExportTaskResult = params => {
    var result = axios.get(`/api/JobTask/ExportTaskResult?userid=${params.UserId}&taskId=${params.taskId}&sdate=${params.StartDate}
    &edate=${params.EndDate}&regionIds=${params.RegionIds}&moduleIds=${params.ModuleIds}&isToday=1`);
    return result;
};

export const GetCallCardDetailPhotoRar = params => {
    var result = axios.post(`/api/CallCard/GetCallCardDetailPhotoRar?callCardId=${params}`);
    return result;
};

export const RegionSubTree = (params) => {
    var result = axios.post(`/api/CityRegion/RegionSubTree`, params);
    return result;
};

export const CreateTrain = (params) => {
    var result = axios.post(`/api/Train/CreateTrain`, params);
    return result;
};

export const Trains = (params) => {
    var result = axios.post(`/api/Train/Trains`, params);
    return result;
};

export const TrainInfo = (params) => {
    var result = axios.post(`/api/Train/TrainInfo`, params);
    return result;
};

export const TrainDetails = (params) => {
    var result = axios.post(`/api/Train/TrainDetails`, params);
    return result;
};

export const TrainDetailInfo = (params) => {
    var result = axios.post(`/api/Train/TrainDetailInfo`, params);
    return result;
};

export const TrainExportbyUser = (params) => {
    var result = axios.post(`/api/Train/TrainExportbyUser`, params);
    return result;
};

export const TrainExportTotalDetails = (params) => {
    var result = axios.post(`/api/Train/TrainExportTotalDetails`, params);
    return result;
};

export const SetTrainStatus = (params) => {
    var result = axios.post(`/api/Train/SetTrainStatus`, params);
    return result;
};

export const DownLoadScoreTemp = (params) => {
    var result = axios.post(`/api/Train/DownLoadScoreTemp`, params);
    return result;
};

export const UploadTrainVideo = (params) => {
    var result = axios.post(`/api/Train/UploadTrainVideo`, params);
    return result;
};

export const GetTrainScoreDetail = (params) => {
    var result = axios.post(`/api/Train/GetTrainScoreDetail?trainDetailId=` + params);
    return result;
};

export const AllCourseCascaderOption = params => {
    if (params == null) params = false;
    var result = axios.get(`/api/Common/AllCourseCascaderOption`, {});
    return result;
};

export const AllPackageCascaderOption = params => {
    if (params == null) params = false;
    var result = axios.get(`/api/Common/AllPackageCascaderOption?CourseId=` + params, {});
    return result;
};

export const GetTrainCourseStatus = params => {
    var result = axios.post(`/api/Train/GetTrainCourseStatus`, params);
    return result;
};

export const SelectTrainerLearner = (params) => {
    var result = axios.post(`/api/User/SelectTrainerLearner?learnerId=${params.UserId}&regionName=${params.CurRegionName}`, {});
    return result;
};

export const DelTrainerLearner = (params) => {
    var result = axios.post(`/api/User/DelTrainerLearner?learnerId=` + params);
    return result;
};

export const SetTrainLearners = (params) => {
    var result = axios.post(`/api/Train/SetTrainLearners`, params);
    return result;
};

export const DelTrainLearners = (params) => {
    var result = axios.post(`/api/Train/DelTrainLearners`, params);
    return result;
};

export const EditTrainLearners = (params) => {
    var result = axios.post(`/api/Train/EditTrainLearners`, params);
    return result;
};

export const GetTrainStatusFiles = (params) => {
    var result = axios.post(`/api/Train/GetTrainStatusFiles?trainId=${params}`, null);
    return result;
};

// 获取课件  api/Train/GetCourseFiles
export const GetCourseFiles = (params) => {
    var result = axios.post(`/api/Train/GetCourseFiles`, params);
    return result;
};
// 设置课件水印  api/Train/SetCourseFilesNeedMark
export const SetCourseFilesNeedMark = (params) => {
    var result = axios.post(`/api/Train/SetCourseFilesNeedMark`, params);
    return result;
};
//删除课件  api/Train/DelCourseFiles?courseFileId=222
export const DelCourseFiles = (params) => {
    var result = axios.post(`/api/Train/DelCourseFiles?courseFileId=${params}`, null);
    return result;
};
// 保存课件 
export const SetCourseFiles = (params) => {
    var result = axios.post(`/api/Train/SetCourseFiles`, params);
    return result;
};
// export const DownCourseFiles = (params) => {
//     var result = axios.post(`/api/Train/DownCourseFiles?courseFileId=${params}`,null );
//     return result;
// };

export const GetDownCourseFiles = (params) => {
    var result = axios.post(`/api/Train/GetDownCourseFiles?courseFileId=${params}`, null);
    return result;
};

export const DelTrainStatusFiles = (params) => {
    var result = axios.post(`/api/Train/DelTrainStatusFiles?trainFileId=${params}`, null);
    return result;
};

export const GetUsersCodes = (params) => {
    var result = axios.post(`/api/User/GetUsersCodes?userNames=${params}`, null);
    return result;
};


export const GetTemplateItemsByEventId = (params) => {
    var result = axios.post(`/api/ComEvent/GetTemplateItemsByEventId?eventId=${params}`, null);
    return result;
};

export const GetTemplatesJson = (params) => {
    var result = axios.post(`/api/JobTask/GetTemplatesJson`);
    return result;
};

export const SaveEventPlan = (params) => {
    var result = axios.post(`/api/ComEvent/SaveEventPlanNew`, params);
    return result;
};

export const GetCalendarPlan = (params) => {
    var result = axios.post(`/api/ComEvent/GetCalendarPlan`, params);
    return result;
};

export const GetPlanByPlanId = (params) => {
    var result = axios.post(`/api/ComEvent/GetPlanByPlanId?planId=${params}`, null);
    return result;
};
//获取计划、执行列表
export const GetPlanAndExecutes = (params) => {
    var result = axios.post(`/api/ComEvent/GetPlanAndExecutes?planId=${params}`, null);
    return result;
};

export const PlanExecutes = (params) => {
    var result = axios.post(`/api/ComEvent/PlanExecutes`, params);
    return result;
};

export const PlanExecutesInfo = (params) => {
    var result = axios.post(`/api/ComEvent/PlanExecutesInfo`, params);
    return result;
};
// 导出  ComEvent/ExportPlanExecutesInfo 
export const ExportPlanExecutesInfo = (params) => {
    var result = axios.post(`/api/ComEvent/ExportPlanExecutesInfo`, params);
    return result;
};

export const DelEventPlan = (params) => {
    var result = axios.post(`/api/ComEvent/DelEventPlan?planId=${params}`);
    return result;
};

export const GetExecuteByPlanId = (params) => {
    var result = axios.post(`/api/ComEvent/GetExecuteByPlanId?oid=${params}`, null);
    return result;
};

export const ExecuteEventPlan = (params) => {
    var result = axios.post(`/api/ComEvent/ExecuteEventPlan`, params);
    return result;
};

export const GetTrainCourses = (params) => {
    var result = axios.post(`/api/Train/GetTrainCourses?oid=${params}`, null);
    return result;
};


export const GetCourseByPlanId = (params) => {
    var result = axios.post(`/api/ComEvent/GetCourseByPlanId?oid=${params}`, null);
    return result;
};

export const ExportEventPlanUrl = (params) => {
    var result = axios.post(`/api/ComEvent/ExportEventPlanUrl?monthDate=${params}`, null);
    return result;
};
export const ExportEventPlanTimesUrl = (params) => {
    var result = axios.post(`/api/ComEvent/ExportEventPlanTimesUrl?monthDate=${params}`, null);
    return result;
};

// 获取老师日程 http://effo.cxish.com/api/ComEvent/GetTrainerPlans
export const GetTrainerPlans = (params) => {
    var result = axios.post(`/api/ComEvent/GetTrainerPlans`, params);
    return result;
};

export const QuestionnairesRateList = (params) => {
    var result = axios.post(`/api/Questionnaire/QuestionnairesRateList`, params);
    return result;
};

export const QuestionnairesRateDetailList = (params) => {
    var result = axios.post(`/api/Questionnaire/QuestionnairesRateDetailList`, params);
    return result;
};

// 导出员工信息

export const ExportUsersInfo = (params) => {
    var result = axios.post(`/api/User/ExportUsersInfo`, params);
    return result;
};
// 下载导入用户错误信息

export const DownLoadUserInErrFiles = (params) => {
    var result = axios.post(`/api/User/DownLoadUserInErrFiles?batchId=${params}`);
    return result;
};
// 批量导入节假日
export const ImportWrokDays = (params) => {
    var result = axios.post(`/api/User/ImportWrokDays`, params);
    return result;
};
// ExportWrokDays
// 批量导出节假日
// export const ExportWrokDays = (params) => {
//     var result = axios.post(`/api/User/ExportWrokDays`, params);
//     return result;
// };
export const ExportWrokDays = params => axios.request({
    url: "/api/User/ExportWrokDays",
    method: "post",
    params,
    transformRequest: [
        function (params) {
            let ret = "";
            for (let it in params) {
                ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(params[it]) +
                    "&";
            }
            return ret;
        }
    ],
    headers: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
})
// 下载导入节假日错误信息
export const DownLoadWrokDaysInErrFiles = (params) => {
    var result = axios.post(`/api/User/DownLoadWrokDaysInErrFiles`, params);
    return result;
};
// 教学项目 树形结构  api/TrainProject/TrainProjectTree
// export const TrainProjectTree = params => {
//     var result = axios.post(`/api/TrainProject/TrainProjectTree`, params);
//     return result;
// };
// 教学项目,教学课程 树形结构  api/TrainProject/TrainProjectCourseTree
export const TrainProjectTree = params => {
    var result = axios.post(`/api/TrainProject/TrainProjectCourseTree`, params);
    return result;
};
// 新增教学项目 api/TrainProject/AddTrainProject
export const AddTrainProject = (params) => {
    var result = axios.post(`/api/TrainProject/AddTrainProject`, params);
    return result;
};
// 修改教学项目 api/TrainProject/EditTrainProject
export const EditTrainProject = (params) => {
    var result = axios.post(`/api/TrainProject/EditTrainProject`, params);
    return result;
};
// 删除教学项目  api/TrainProject/DelTrainProject?rid=0
export const DelTrainProject = (params) => {
    var result = axios.post(`/api/TrainProject/DelTrainProject?rid=${params}`, null);
    return result;
};

// 新增课程  api/TrainProject/AddTrainCourse
export const AddTrainCourse = (params) => {
    var result = axios.post(`/api/TrainProject/AddTrainCourse`, params);
    return result;
};
// 修改课程 api/TrainProject/EditTrainCourse
export const EditTrainCourse = (params) => {
    var result = axios.post(`/api/TrainProject/EditTrainCourse`, params);
    return result;
};
// 删除课程  api/TrainProject/DelTrainCourse?rid=111111
export const DelTrainCourse = (params) => {
    var result = axios.post(`/api/TrainProject/DelTrainCourse?rid=${params}`, null);
    return result;
};
// 查看课件包  api/TrainProject/GetTrainCourseFolder?courseId=1
export const GetTrainCourseFolder = (params) => {
    var result = axios.post(`/api/TrainProject/GetTrainCourseFolder?courseId=${params}`, null);
    return result;
};
// 新增课件包  api/TrainProject/AddTrainCourseFolder
export const AddTrainCourseFolder = (params) => {
    var result = axios.post(`/api/TrainProject/AddTrainCourseFolder`, params);
    return result;
};

//删除 api/TrainProject/DelTrainCourseFolder?rid=0
export const DelTrainCourseFolder = (params) => {
    var result = axios.post(`/api/TrainProject/DelTrainCourseFolder?rid=${params}`, null);
    return result;
};

// 获取事业部、分线部门、省区区域、办事处名称、职位信息  api/Common/DictRegionsOption
export const DictRegionsOption = (params) => {
    var result = axios.post(`/api/Common/DictRegionsOption`, params);
    return result;
};

// 获取日历计划
// POST /api/ComEvent/GetMonthyCallList
export const GetMonthyCallList = (params) => {
    var result = axios.post(`/api/ComEvent/GetMonthyCallList`, params);
    return result;
};
export const GetCourseFilesByTaskId = (params) => {
    var result = axios.post(`/api/Train/GetCourseFilesByTaskId?oid=${params}`, null);
    return result;
};

// 评分模版列表  api/JobTask/GetScoreTask
export const GetScoreTask = (params) => {
    var result = axios.post(`/api/JobTask/GetScoreTask`, params);
    return result;
};

//创建评分模版 api/JobTask/CreateScoreTask
export const CreateScoreTask = (params) => {
    var result = axios.post(`/api/JobTask/CreateScoreTask`, params);
    return result;
};

// 评分模版明细  api/JobTask/GetScoreTemplateDetail?TemplateId=1
export const GetScoreTemplateDetail = (params) => {
    var result = axios.post(`/api/JobTask/GetScoreTemplateDetail?TemplateId=${params}`, null);
    return result;
};
// 删除评分模板
export const DelScoreTemplate = (params) => {
    var result = axios.post(`/api/JobTask/DelScoreTemplate?TemplateId=${params}`, null);
    return result;
};
// 导出学员评分  api/Train/TrainExportScore
export const TrainExportScore = (params) => {
    var result = axios.post(`/api/Train/TrainExportScore`, params);
    return result;
};

// 获取问卷列表  api/JobTask/GetQuestionnaireTask
export const GetQuestionnaireTask = (params) => {
    var result = axios.post(`/api/JobTask/GetQuestionnaireTask`, params);
    return result;
};
// 下载模板数据
export const GetQuestionnaireTemplate = (params) => {
    var result = axios.post(`/api/JobTask/GetQuestionnaireTemplate?TemplateId=${params}`, null);
    return result;
};

// 导出问卷
export const QuestionnaireExport = (params) => {
    var result = axios.post(`/api/Train/QuestionnaireExport`, params);
    return result;
};
// 设置培训学员分组、排序功能  api/Train/SetTrainDetailSorts
// ps:Types =1 表示修改分组 2 表示修改排序
export const SetTrainDetailSorts = (params) => {
    var result = axios.post(`/api/Train/SetTrainDetailSorts`, params);
    return result;
};

// 获取课程老师 api/TrainProject/GetCourseUser?courseId=1
export const GetCourseUser = (params) => {
    var result = axios.post(`/api/TrainProject/GetCourseUser?courseId=${params}`, null);
    return result;
};

//保存认证老师 api/TrainProject/SetCourseUser?courseId=1
export const SetCourseUser = (params) => {
    var result = axios.post(`/api/TrainProject/SetCourseUser?courseId=${params.Id}&userids=${params.userIds}`, {});
    return result;
};

// --------------------  信息资讯 ---------------------------
//上传文件 /api/File/UploadSvc
export const UploadSvc = params => {
    var result = axios.post(`/api/File/UploadSvc`, params, {
        headers: { "content-type": "multipart/form-data" }
    });
    return result;
}


// 新增文件信息  api/FileManages/AddFileMsg
export const addFileMsg = (params) => {
    var result = axios.post(`/api/FileManages/AddFileMsg`, params);
    return result;
};

//  获取文件消息列表  api/FileManages/GetMessageList
export const getFileMsgList = (params) => {
    var result = axios.post(`/api/FileManages/GetMessageListByWeb`, params);
    return result;
};
// api/FileManages/GetMessageListByWeb
// export const getFileMsgList = (params) => {
//     var result = axios.post(`/api/FileManages/GetMessageList`, params);
//     return result;
// };

// 删除文件 api/FileManages/DeleteFileMsg
export const deleteFileMsg = (params) => {
    var result = axios.post(`/api/FileManages/DeleteFileMsg`, params);
    return result;
};

// 获取文件信息 api/FileManages/GetFileInfos?fid=1&uuids=1
export const getFileInfos = (params) => {
    var result = axios.post(`/api/FileManages/GetFileInfos?fid=${params.fid}&uuids=${params.uuids}`, {});
    return result;
};

// 获取遮盖层信息 api/FileManages/GetCoverFileInfos?fid=1
export const getCoverFileInfos = (params) => {
    var result = axios.post(`/api/FileManages/GetCoverFileInfos?fid=${params}`, {});
    return result;
};

// 导出文件 api/FileManages/GetProveFileMsgRimExport
export const getProveFileMsgRimExport = (params) => {
    var result = axios.post(`/api/FileManages/GetProveFileMsgRimExport`, params);
    return result;
};

//获取富文本内容  api/FileManages/GetMessageDetailList/1
export const GetMessageDetailList = (params) => {
    var result = axios.post(`/api/FileManages/GetMessageDetailList/${params}`, {});
    return result;
};


// 查看详细网页 api/FileManages/GetMessageDetailListById/1?uid=1
export const getFileMsgDetailList = params => {
    var result = axios.post(`/api/FileManages/GetMessageDetailListById/${params.ID}?uid=${params.uid}`);
    return result;
};
// 获取附件的链接 api/Train/GetDownFileById?UserId=2&fileId=11
export const GetDownFileById = params => {
    var result = axios.post(`/api/Train/GetDownFileById?UserId=${params.UserId}&fileId=${params.fileId}`);
    return result;
};

// 提交评论  api/FileManages/SendMessageCommentsById1/1?UserId=1&Comments=1
export const SendMessage = params => {
    var result = axios.post(`/api/FileManages/SendMessageCommentsById1/${params.ID}?UserId=${params.UserId}&Comments=${params.Comments}`);
    return result;
};
// 点赞  api/FileManages/ThumbsUpMessageById1/11?UserId=2
export const ThumbsUp = params => {
    var result = axios.post(`/api/FileManages/ThumbsUpMessageById1/${params.ID}?UserId=${params.UserId}`);
    return result;
};
// 网课 获取学员 api/User/NetCourseUsers
export const getNetCourseUsers = params => {
    var result = axios.post(`/api/User/NetCourseUsers`, params);
    return result;
};
// 网课 添加学员 api/Train/SetNetCourseLearners
export const SetNetCourseLearners = (params) => {
    var result = axios.post(`/api/Train/SetNetCourseLearners`, params);
    return result;
};
// 云课 删除学员 api/Train/DelNetCourseUsers
export const DelNetCourseUsers = (params) => {
    var result = axios.post(`/api/Train/DelNetCourseUsers`, params);
    return result;
};
// 上传个人简介  api/File/UploadSync
export const UploadSync = (params) => {
    var result = axios.post(`/api/File/UploadSync`, params);
    return result;
};
// 课程分组管理  
// 搜索查询 api/FileManages/GetCourseGroupList
export const GetCourseGroupList = (params) => {
    var result = axios.post(`/api/FileManages/GetCourseGroupList`, params);
    return result;
};
// 添加分组 api/FileManages/SetCourseGroup
export const SetCourseGroup = (params) => {
    var result = axios.post(`/api/FileManages/SetCourseGroup`, params);
    return result;
};
// 获取人员管理列表 api/FileManages/GetCourseUserHeadList?groupId=1
export const GetCourseUserHeadList = params => {
    var result = axios.post(`/api/FileManages/GetCourseUserHeadList?groupId=${params}`);
    return result;
};
// 获取部门岗位列表  api/FileManages/GetDepartmentAndPositionList
export const GetDepartmentAndPositionList = () => {
    var result = axios.post(`/api/FileManages/GetDepartmentAndPositionList`, "");
    return result;
};
// 保存部门职位 api/FileManages/SetCourseUserHeadList
export const SetCourseUserHeadList = (params) => {
    var result = axios.post(`/api/FileManages/SetCourseUserHeadList`, params);
    return result;
};
// 获取课程树 AllNetCourseCascaderOption
export const AllNetCourseCascaderOption = params => {
    if (params == null) params = false;
    var result = axios.get(`/api/Common/AllNetCourseCascaderOption`, {});
    return result;
};

// 获取课程表格 api/FileManages/GetGroupCourseList?groupId=1
export const GetGroupCourseList = params => {
    var result = axios.post(`/api/FileManages/GetGroupCourseList?groupId=${params}`);
    return result;
};
// 选择课程时 api/FileManages/SetGroupCourse
export const SetGroupCourse = (params) => {
    var result = axios.post(`/api/FileManages/SetGroupCourse`, params);
    return result;
};

// 获取网课审批状态 api/FileManages/GetNetCourseWorkFlow?netcourseId=1&userId=12
export const GetNetCourseWorkFlow = params => {
    var result = axios.post(`/api/FileManages/GetNetCourseWorkFlow?netcourseId=${params.netcourseId}&userId=${params.userId}`);
    return result;
};

// 网课审批操作  api/FileManages/SetNetCourseWorkFlowStatus
export const SetNetCourseWorkFlowStatus = params => {
    var result = axios.post(`/api/FileManages/SetNetCourseWorkFlowStatus`, params);
    return result;
};
// 设置课程节点树  api/TrainProject/TrainProjectTree
export const TetProjectTree = params => {
    if (params == null) params = false;
    var result = axios.post(`/api/TrainProject/TrainProjectTree`, {});
    return result;
};
// 获取职位树 api/CityRegion/GetPositionList
export const GetPositionList = params => {
    var result = axios.post(`/api/CityRegion/GetPositionList`, params);
    return result;
};
// 分组管理 导入错误信息 
export const DownLoadNetCourseUsersInErrFiles = params => {
    var result = axios.post(`/api/User/DownLoadNetCourseUsersInErrFiles?batchId=${params}`);
    return result;
};
// 导出 DownLoadNetCourseUsers api/User/DownLoadNetCourseUsers?groupid=2&type=1
export const DownLoadNetCourseUsers = params => {
    var result = axios.post(`/api/User/DownLoadNetCourseUsers?groupid=${params.groupId}&type=${params.type}`);
    return result;
};
// 查看老师计划安排 api/ComEvent/GetTrainerPlanTimes
export const GetTrainerPlanTimes = params => {
    var result = axios.post(`/api/ComEvent/GetTrainerPlanTimes`, params);
    return result;
};
// 获取分类分线数据 api/FileManages/GetFenLeiList?parentid=1
export const GetFenLeiList = params => {
    var result = axios.post(`/api/FileManages/GetFenLeiList?parentid=${params}`);
    return result;
};
// 导出网课  api/FileManages/ExportMessageList
export const ExportMessageList = (params) => {
    var result = axios.post(`/api/FileManages/ExportMessageList`, params);
    return result;
};
// 删除上传成绩/补考成绩 api/Train/DelTrainCourseScore?TrainDetailId=3&scoreType=1
export const DelTrainCourseScore = params => {
    var result = axios.post(`/api/Train/DelTrainCourseScore?TrainDetailId=${params.TrainDetailId}&scoreType=${params.scoreType}`);
    return result;
};
// 删除上传视频/补考视频 api/Train/DelTrainCourseFile?TrainDetailId=1&scoreType=1
export const DelTrainCourseFile = params => {
    var result = axios.post(`/api/Train/DelTrainCourseFile?TrainDetailId=${params.TrainDetailId}&scoreType=${params.scoreType}`);
    return result;
};
// 教学项目课程下的课件包-课件  api/TrainProject/TrainProjectCourseNodeFiles?courseId=1
export const TrainProjectCourseNodeFiles = params => {
    var result = axios.post(`/api/TrainProject/TrainProjectCourseNodeFiles?courseId=${params}`);
    return result;
};
// 历史停用课件  api/TrainProject/TrainProjectCourseNodeHisFiles?packageId=1
export const TrainProjectCourseNodeHisFiles = params => {
    var result = axios.post(`/api/TrainProject/TrainProjectCourseNodeHisFiles?packageId=${params}`);
    return result;
};
// 设置计划关联项目 api/Common/GetProjectList
export const GetProjectList = params => {
    var result = axios.post(`/api/Common/GetProjectList`, params);
    return result;
};
// 关联项目项目分阶段 api/Common/GetProjectPhaseList?projectId=1
export const GetProjectPhaseList = params => {
    var result = axios.post(`/api/Common/GetProjectPhaseList?projectId=${params}`);
    return result;
};

// 课程认证 错误信息下载 api/FileManages/ExportAuthSignUsersErrorFiles?banthId=1
export const ExportAuthSignUsersErrorFiles = params => {
    var result = axios.post(`/api/FileManages/ExportAuthSignUsersErrorFiles?banthId=${params}`);
    return result;
};

// 交作业 作业列表 api/FileManages/GetLearnWorkList
export const GetLearnWorkList = params => {
    var result = axios.post(`/api/FileManages/GetLearnWorkList`, params);
    return result;
};
// 导出认证日程  api/FileManages/ExportAuthSignUsersFiles
export const ExportAuthSignUsersFiles = params => {
    var result = axios.post(`/api/FileManages/ExportAuthSignUsersFiles`, params);
    return result;
};

// 获取评分列表  api/Train/GetAuthCourseStatus
export const GetAuthCourseStatus = params => {
    var result = axios.post(`/api/Train/GetAuthCourseStatus`, params);
    return result;
};

// 导出备课笔记-下载作业 api/FileManages/ExporttLearnWorkFiles
export const ExporttLearnWorkFiles = params => {
    var result = axios.post(`/api/FileManages/ExporttLearnWorkFiles`, params);
    return result;
};
// 驳回作业  api/FileManages/DelLearnWorkById/11
export const DelLearnWorkById = params => {
    var result = axios.post(`/api/FileManages/DelLearnWorkById/${params}`);
    return result;
};

// 查看评委打分 api/Train/GetAuthJudgesScoreList/11
export const GetAuthJudgesScoreList = params => {
    var result = axios.post(`/api/Train/GetAuthJudgesScoreList/${params}`);
    return result;
};
//发布成绩  api/Train/PublishAuthScore/11
export const PublishAuthScore = params => {
    var result = axios.post(`/api/Train/PublishAuthScore/${params}`);
    return result;
};
// 作废评委打分  api/Train/DelAuthJudgesScore/11
export const DelAuthJudgesScore = params => {
    var result = axios.post(`/api/Train/DelAuthJudgesScore/${params}`);
    return result;
};
// 获取已发布成绩 api/Train/ExportAuthPublishScoreList
export const ExportAuthPublishScoreList = params => {
    var result = axios.post(`/api/Train/ExportAuthPublishScoreList`, params);
    return result;
};

// 获取地址 api/FileManages/GetMaterialAddress
export const GetMaterialAddress = params => {
    var result = axios.post(`/api/FileManages/GetMaterialAddress`, params);
    return result;
};
// 设置地址  api/FileManages/SetMaterialAddress
export const SetMaterialAddress = params => {
    var result = axios.post(`/api/FileManages/SetMaterialAddress`, params);
    return result;
};
// 获取物料表 api/FileManages/GetMaterialApply
export const GetMaterialApply = params => {
    var result = axios.post(`/api/FileManages/GetMaterialApply`, params);
    return result;
};
// 申请物料 api/FileManages/SetMaterialApply
export const SetMaterialApply = params => {
    var result = axios.post(`/api/FileManages/SetMaterialApply`, params);
    return result;
};
// 获取物料课程 api/FileManages/GetMaterialCourseList
export const GetMaterialCourseList = params => {
    if (params == null) params = false;
    var result = axios.post(`/api/FileManages/GetMaterialCourseList`, {});
    return result;
};

//物料取消1 发放2   api/FileManages/SetMaterialApplyStatus
export const SetMaterialApplyStatus = params => {
    var result = axios.post(`/api/FileManages/SetMaterialApplyStatus`, params);
    return result;
};
// 老师库存 api/FileManages/GetMaterialUserInvInfo
export const GetMaterialUserInvInfo = params => {
    var result = axios.post(`/api/FileManages/GetMaterialUserInvInfo`, params);
    return result;
};
// 导出物料 api/FileManages/ExportMaterialApply
export const ExportMaterialApply = params => {
    var result = axios.post(`/api/FileManages/ExportMaterialApply`, params);
    return result;
};
// 获取培训场次 api/FileManages/GetMappingTrainList
export const GetMappingTrainList = params => {
    var result = axios.post(`/api/FileManages/GetMappingTrainList`, params);
    return result;
};
// 物料匹配 删除  api/FileManages/SetMaterialUse
export const SetMaterialUse = params => {
    var result = axios.post(`/api/FileManages/SetMaterialUse`, params);
    return result;
};
// 物料使用情况 api/FileManages/GetMaterialUseList
export const GetMaterialUseList = params => {
    var result = axios.post(`/api/FileManages/GetMaterialUseList`, params);
    return result;
};
// 报表中心 FileManages/ExportReportList
export const ExportReportList = params => {
    var result = axios.post(`/api/FileManages/ExportReportList`, params);
    return result;
};
//  培训人次统计
export const GetTrainKpi = params => {
    var result = axios.post(`/api/FileManages/GetTrainKpi`, params);
    return result;
};
// 学院培训统计
export const GetBDTrainKpi = params => {
    var result = axios.post(`/api/FileManages/GetBDTrainKpi`, params);
    return result;
};
// 培训成绩分布汇总
export const GetTrainScoreKpi = params => {
    var result = axios.post(`/api/FileManages/GetTrainScoreKpi`, params);
    return result;
};
// 培训合格率汇总 
export const GetTrainPassRateKpi = params => {
    var result = axios.post(`/api/FileManages/GetTrainPassRateKpi`, params);
    return result;
};
// 事业部培训合格率
export const GetBDTrainPassRateKpi = params => {
    var result = axios.post(`/api/FileManages/GetBDTrainPassRateKpi`, params);
    return result;
};
// FileManages/GetWorkloadKpi获取工作量
export const GetWorkloadKpi = params => {
    var result = axios.post(`/api/FileManages/GetWorkloadKpi`, params);
    return result;
};
// 获取项目列表
export const GetCRCProjectList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCProjectList`, params);
    return result;
};
//  项目列表  导出
export const ExportCRCProjectList = params => {
    var result = axios.post(`/api/CRCProject/ExportCRCProjectList`, params);
    return result;
};
//创建项目
export const AddCRCProject = (params) => {
    var result = axios.post(`/api/CRCProject/AddCRCProject`, params);
    return result;
};
//批量导入
export const ImportCenterData = params => {
    var result = axios.post(`/api/CRCProject/ImportCenterData`, params);
    return result;
};
//获取中心团队信息
export const GetProjectCenterUsers = params => {
    var result = axios.post(`/api/CRCProject/GetProjectCenterUsers?ProjectId=${params}`);
    return result;
};
//获取项目合同列表
export const GetCRCProjectContractList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCProjectContractList?ProjectId=${params}`);
    return result;
};
//获取奖金管理列表
export const GetProjectBonus = params => {
    var result = axios.post(`/api/CRCProject/GetProjectBonus?ProjectId=${params}`);
    return result;
};
//新增合同
export const AddCRCProjectContract = params => {
    var result = axios.post(`/api/CRCProject/AddCRCProjectContract`, params);
    return result;
};
//设置奖金管理
export const SetProjectBonus = params => {
    var result = axios.post(`/api/CRCProject/SetProjectBonus`, params);
    return result;
};
//新增备忘录
export const SetProjectLog = params => {
    var result = axios.post(`/api/CRCProject/SetProjectLog`, params);
    return result;
};
//删除项目
export const DelCRCProject = params => {
    var result = axios.post(`/api/CRCProject/DelCRCProject?ProjectId=${params.ProjectId}`);
    return result;
};
export const GetCRCProjectManagerList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCProjectManagerList`, params);
    return result;
};
//删除合同
export const DelCRCProjectContract = params => {
    var result = axios.post(`/api/CRCProject/DelCRCProjectContract/${params.Id}`);
    return result;
};
//获取备忘录列表
export const GetProjectLogList = params => {
    var result = axios.post(`/api/CRCProject/GetProjectLogList?PayconfigId=${params}`);
    return result;
};
//批量导入合同执行数据
export const ImportHtTemplateData = params => {
    var result = axios.post(`/api/CRCProject/ImportHtTemplateData`, params);
    return result;
};
//下载合同执行数据
export const ExportHtTemplateData = params => {
    var result = axios.post(`/api/CRCProject/ExportHtTemplateData?ProjectId=${params}`);
    return result;
};

export const ApproveCenterUser = params => {
    var result = axios.post(`/api/CRCProject/ApproveCenterUser`, params);
    return result;
};//考试列表
export const GetExaminationList = params => {
    var result = axios.post(`/api/CRCProject/GetExaminationList`, params);
    return result;
};
//题库列表
export const GetQuestionBankList = params => {
    var result = axios.post(`/api/CRCProject/GetQuestionBankList`, params);
    return result;
};
//带教列表
export const GetTeachList = params => {
    var result = axios.post(`/api/CRCProject/GetTeachList`, params);
    return result;
};
//请款备注
export const SetContractRequestPay = params => {
    var result = axios.post(`/api/CRCProject/SetContractRequestPay`, params);
    return result;
};
//开票备注
export const SetContractInvoic = params => {
    var result = axios.post(`/api/CRCProject/SetContractInvoic`, params);
    return result;
};
//支付备注 
export const SetContractPayment = params => {
    var result = axios.post(`/api/CRCProject/SetContractPayment`, params);
    return result;
};
//设置考试
export const SetExamination = params => {
    var result = axios.post(`/api/CRCProject/SetExamination`, params);
    return result;
};
//删除题库
export const DelQuestionBank = params => {
    var result = axios.post(`/api/CRCProject/DelQuestionBank/${params.Id}`);
    return result;
};
//批量导入带教信息
export const ImportTeachData = params => {
    var result = axios.post(`/api/CRCProject/ImportTeachData`, params);
    return result;
};
//批量导入题库
export const ImportQuestionBankData = params => {
    var result = axios.post(`/api/CRCProject/ImportQuestionBankData`, params);
    return result;
};
//添加删除考试人员
export const SetExaminationUser = params => {
    var result = axios.post(`/api/CRCProject/SetExaminationUser`, params);
    return result;
};
//获取人员
export const GetExaminationUserList = (params) => {
    var result = axios.post(`/api/CRCProject/GetExaminationUserList`, params);
    return result;
};
//获取工作记录
export const GetWorkList = (params) => {
    var result = axios.post(`/api/CRCProject/GetWorkList`, params);
    return result;
};
//设置分配管理
export const SetCRCProjectManager = (params) => {
    var result = axios.post(`/api/CRCProject/SetCRCProjectManager?ProjectId=${params.ProjectId}&userId=${params.userId}`);
    return result;
};
export const SetCenterUser = (params) => {
    var result = axios.post(`/api/CRCProject/SetCenterUser`, params);
    return result;
};
GetProjectCenterUserList
//获取中心团队信息
export const GetProjectCenterUserList = params => {
    var result = axios.post(`/api/CRCProject/GetProjectCenterUserList`, params);
    return result;
};
//获取合同执行数据
export const GetHtTemplateList = params => {
    var result = axios.post(`/api/CRCProject/GetHtTemplateList?ProjectId=${params}`);
    return result;
};
//获取合同执行数据
export const GetPMHtTemplateList = params => {
    var result = axios.post(`/api/CRCProject/GetPMHtTemplateList?ProjectId=${params}`);
    return result;
};
//修改项目合作进展信息（ 意愿沟通中 报价中 落选 中标 ）
export const SetCRCProjectStatus = params => {
    var result = axios.post(`/api/CRCProject/SetCRCProjectStatus`, params);
    return result;
};
// 获取中心列表
export const GetCRCCenterList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCCenterList`, params);
    return result;
};
// 修改中心列表
export const SetCRCCenterInfo = params => {
    var result = axios.post(`/api/CRCProject/SetCRCCenterInfo`, params);
    return result;
};
//  导出中心模版
export const ExportCRCCenterList = params => {
    var result = axios.post(`/api/CRCProject/ExportCRCCenterList`, params);
    return result;
};
//  项目任务设定列表
export const GetProjectPlanList = params => {
    var result = axios.post(`/api/CRCProject/GetProjectPlanList`, params);
    return result;
};
//  项目任务设定列表  导入
export const ImportProjectPlanData = params => {
    var result = axios.post(`/api/CRCProject/ImportProjectPlanData`, params);
    return result;
};
//  项目任务设定列表  导出
export const ExportProjectPlanData = params => {
    var result = axios.post(`/api/CRCProject/ExportProjectPlanData`, params);
    return result;
};//  CRC项目任务设定列表  POST /api/CRCProject/
export const GetProjectPlanCRCList = params => {
    var result = axios.post(`/api/CRCProject/GetProjectPlanCRCList`, params);
    return result;
};
//  CRC项目任务设定列表  导入 
export const ImportProjectPlanCRCData = params => {
    var result = axios.post(`/api/CRCProject/ImportProjectPlanCRCData`, params);
    return result;
};
//  CRC项目任务设定列表  导出  
export const ExportProjectPlanCRCData = params => {
    var result = axios.post(`/api/CRCProject/ExportProjectPlanCRCData`, params);
    return result;
};
//  项目中心周报
export const GetCenterMonthyReportList = params => {
    var result = axios.post(`/api/CRCProject/GetCenterMonthyReportList`, params);
    return result;
};
//导出项目中心周报 POST 
export const ExportCenterMonthyReport = params => {
    var result = axios.post(`/api/CRCProject/ExportCenterMonthyReport`, params);
    return result;
};
export const GetProjectTeamReportList = params => {
    var result = axios.post(`/api/CRCProject/GetProjectTeamReportList`, params);
    return result;
};
//导出项目团队 POST 
export const ExportProjectTeamReport = params => {
    var result = axios.post(`/api/CRCProject/ExportProjectTeamReport`, params);
    return result;
};
//  CRC工时记录  POST 
export const GetCRCWorkReportList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCWorkReportList`, params);
    return result;
};
// 导出CRC工时审核记录   
export const ExportCRCWorkAprReport = params => {
    var result = axios.post(`/api/CRCProject/ExportCRCWorkAprReport`, params);
    return result;
};
// 导出CRC工时记录   
export const ExportCRCWorkReport = params => {
    var result = axios.post(`/api/CRCProject/ExportCRCWorkReport`, params);
    return result;
};
//  中心每日入组、访视进展
export const GetCRCCenterDaylyReportList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCCenterDaylyReportList`, params);
    return result;
};
// 导出中心每日入组、访视进展 
export const ExportCRCCenterDaylyReport = params => {
    var result = axios.post(`/api/CRCProject/ExportCRCCenterDaylyReport`, params);
    return result;
};
//  项目财务报告
export const GetCRCFinancialReportList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCFinancialReportList`, params);
    return result;
};
// 导出项目财务报告
export const ExportFinancialReport = params => {
    var result = axios.post(`/api/CRCProject/ExportFinancialReport`, params);
    return result;
};
//  项目报告
export const GetCRCProjectReportList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCProjectReportList`, params);
    return result;
};
// 导出项目报告
export const ExportProjectReport = params => {
    var result = axios.post(`/api/CRCProject/ExportProjectReport`, params);
    return result;
};
//  区域月任务完成报告
export const GetAreaTargetReportList = params => {
    var result = axios.post(`/api/CRCProject/GetAreaTargetReportList`, params);
    return result;
};
// 导出区域月任务完成报告
export const ExportAreaTargetReport = params => {
    var result = axios.post(`/api/CRCProject/ExportAreaTargetReport`, params);
    return result;
};
//  项目月任务完成报告
export const GetMonthyActiveReportList = params => {
    var result = axios.post(`/api/CRCProject/GetMonthyActiveReportList`, params);
    return result;
};
// 导出项目月任务完成报告 POST 
export const ExportMonthyActiveReport = params => {
    var result = axios.post(`/api/CRCProject/ExportMonthyActiveReport`, params);
    return result;
};
//  项目随访数据 
export const GetVisitReportList = params => {
    var result = axios.post(`/api/CRCProject/GetVisitReportList`, params);
    return result;
};
// 导出项目随访数据
export const ExportVisitReport = params => {
    var result = axios.post(`/api/CRCProject/ExportVisitReport`, params);
    return result;
};
//获取项目列表
export const GetWorkProjectList = params => {
    var result = axios.post(`/api/CRCProject/GetWorkProjectList?type=${params}`);
    return result;
};
//  项目随访知情  POST 
export const GetCRCPatientList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCPatientList`, params);
    return result;
};
// 导出项目知情数据  POST 
export const ExportCRCPatientList = params => {
    var result = axios.post(`/api/CRCProject/ExportCRCPatientList`, params);
    return result;
};
// 修改项目知情数据  POST 
export const SetCRCPatientInfo = params => {
    var result = axios.post(`/api/CRCProject/SetCRCPatientInfo`, params);
    return result;
};
//  区域日报  POST 
export const GetAreaDaylyReportList = params => {
    var result = axios.post(`/api/CRCProject/GetAreaDaylyReportList`, params);
    return result;
};
// 导出区域日报
export const ExportAreaDaylyReport = params => {
    var result = axios.post(`/api/CRCProject/ExportAreaDaylyReport`, params);
    return result;
};

//  区域人员工作量  POST 
export const GetAreaUserWkRpt = params => {
    var result = axios.post(`/api/CRCProject/GetAreaUserWkRpt`, params);
    return result;
};
// 导出区域人员工作量
export const ExportAreaUserWkRpt = params => {
    var result = axios.post(`/api/CRCProject/ExportAreaUserWkRpt`, params);
    return result;
};

// 导出区域日报中的汇总日报
export const ExportAreaDaylyReportTol = params => {
    var result = axios.post(`/api/CRCProject/ExportAreaDaylyReportTol`, params);
    return result;
};
//获取资金收益情况日报
export const GetCapitalincomePlan = params => {
    var result = axios.post(`/api/CRCProject/GetCapitalincomePlan?hisMonth=${params}`);
    return result;
};
//获取资金收益情况月报 GetCapitalincomePlanByYear 
export const GetCapitalincomePlanByYear = params => {
    var result = axios.post(`/api/CRCProject/GetCapitalincomePlanByYear?hisMonth=${params}`);
    return result;
};
// 设置资金收益月指标
export const SetCapitalincomeDepPlan = params => {
    var result = axios.post(`/api/CRCProject/SetCapitalincomeDepPlan`, params);
    return result;
};

// 设置资金收益月指标-按天
export const SetCapitalincomeDayPlan = params => {
    var result = axios.post(`/api/CRCProject/SetCapitalincomeDayPlan`, params);
    return result;
};
// 
export const GetCapitalincomeRpt = params => {
    var result = axios.post(`/api/CRCProject/GetCapitalincomeRpt`, params);
    return result;
};
//删除知情数据
export const DelCRCPatientInfo = params => {
    var result = axios.post(`/api/CRCProject/DelCRCPatientInfo/${params}`);
    return result;
};
//  商务报告
export const GetCRCBusinesReportList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCBusinesReportList`, params);
    return result;
};
// 导出项目随访数据
export const ExportBusinesReport = params => {
    var result = axios.post(`/api/CRCProject/ExportBusinesReport`, params);
    return result;
};
// 获取PM审核列表
export const GetCRCWorkAprList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCWorkAprList`, params);
    return result;
};
// PM审核列表同意 or 拒绝
export const SetCRCWorkApr = params => {
    var result = axios.post(`/api/CRCProject/SetCRCWorkApr`, params);
    return result;
};
// PM审核列表 批量同意 or 批量拒绝
export const SetCRCWorkAprBatch = params => {
    var result = axios.post(`/api/CRCProject/SetCRCWorkAprBatch`, params);
    return result;
};
// 目标回款 DepartId （1 商务发展部 2 项目管理部 3 区域商务部 4 生物样本部 6 临床协调部）
export const GetTargetCollectionList = params => {
    var result = axios.post(`/api/CRCProject/GetTargetCollectionList`, params);
    return result;
};
// 设置目标回款
export const SetTargetCollection = params => {
    var result = axios.post(`/api/CRCProject/SetTargetCollection`, params);
    return result;
};
// 删除目标回款
export const DelTargetCollection = params => {
    var result = axios.post(`/api/CRCProject/DelTargetCollection/${params}`);
    return result;
};

// 获取目标回款总表
export const GetTargetCollectionTolList = params => {
    var result = axios.post(`/api/CRCProject/GetTargetCollectionTolList`, params);
    return result;
};
// 导出目标回款总表
export const ExportTargetCollectionTolList = params => {
    var result = axios.post(`/api/CRCProject/ExportTargetCollectionTolList`, params);
    return result;
};
// 导出目标回款总表
export const ExportTargetCollectionList = params => {
    var result = axios.post(`/api/CRCProject/ExportTargetCollectionList`, params);
    return result;
};
// 获取资金收益总表
export const GetCRCCapitalincomeTol = params => {
    var result = axios.post(`/api/CRCProject/GetCRCCapitalincomeTol`, params);
    return result;
};
// 获取绩效考核明细表 
export const GetCRCMonthyBonusReportList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCMonthyBonusReportList`, params);
    return result;
};
// 导出绩效考核明细表
export const ExportCRCMonthyBonusReport = params => {
    var result = axios.post(`/api/CRCProject/ExportCRCMonthyBonusReport`, params);
    return result;
};
// 获取执行额表
export const GetIMPAmountList = params => {
    var result = axios.post(`/api/CRCProject/GetIMPAmountList`, params);
    return result;
};
// 获取执行额表
export const SetIMPAmount = params => {
    var result = axios.post(`/api/CRCProject/SetIMPAmount`, params);
    return result;
};
// 导出执行额表
export const ExportIMPAmountList = params => {
    var result = axios.post(`/api/CRCProject/ExportIMPAmountList`, params);
    return result;
};

export const ImportIMPAmountData = params => {
    var result = axios.post('/api/CRCProject/ImportIMPAmountData', params);
    return result;
}
export const GetSWProjectList = params => {
    var result = axios.post('/api/CRCProject/GetSWProjectList', params);
    return result;
}

export const AddSWProject = params => {
    var result = axios.post('/api/CRCProject/AddSWProject', params);
    return result;
}
export const SetSWProjectStatus = params => {
    var result = axios.post('/api/CRCProject/SetSWProjectStatus', params);
    return result;
}
export const GetSWProjectSurveyList = params => {
    var result = axios.post('/api/CRCProject/GetSWProjectSurveyList', params);
    return result;
}
// 获取质量报告
export const GetQualityRptList = params => {
    var result = axios.post('/api/TrainProject/GetQualityRptList', params);
    return result;
}
export const GetTemplatesList = params => {
    var result = axios.post(`/api/TrainProject/GetTemplatesList?TemplateId=${params}`);
    return result;
};
// 修改质量报告
export const SetQualityRptList = params => {
    var result = axios.post('/api/TrainProject/SetQualityRptList', params);
    return result;
}
export const ImportSWProjectSurveyData = params => {
    var result = axios.post('/api/CRCProject/ImportSWProjectSurveyData', params);
    return result;
}
export const ExportSWProjectData = params => {
    var result = axios.post('/api/CRCProject/ExportSWProjectData', params);
    return result;
}
export const ExportSWProjectSurveyData = params => {
    var result = axios.post('/api/CRCProject/ExportSWProjectSurveyData', params);
    return result;
}
export const GetObjectList = params => {
    var result = axios.post('/api/TrainProject/GetObjectList', params);
    return result;
}

export const SetPMWorkInfo = params => {
    var result = axios.post('/api/CRCProject/SetPMWorkInfo', params);
    return result;
}
export const SetWorkInfo = params => {
    var result = axios.post('/api/CRCProject/SetWorkInfo', params);
    return result;
}
export const ExportPMHtTemplateData = params => {
    var result = axios.post(`/api/CRCProject/ExportPMHtTemplateData?ProjectId=${params}`);
    return result;
}
export const GetPMWorkReportList = params => {
    var result = axios.post(`/api/CRCProject/GetPMWorkReportList`, params);
    return result;
}
export const AllWorkTypeOption = params => {
    var result = axios.post(`/api/CRCProject/AllWorkTypeOption?type=${params.type}&ProjectId=${params.ProjectId}`);
    return result;
}
export const AuthCallList = params => {
    var result = axios.post(`/api/TrainProject/AuthCallList`, params);
    return result;
}
export const ExportPMWorkReport = params => {
    var result = axios.post(`/api/CRCProject/ExportPMWorkReport`, params);
    return result;
}
export const GetPMExeAmountList = params => {
    var result = axios.post(`/api/CRCProject/GetPMExeAmountList`, params);
    return result;
}
export const ExportPMExeAmountReport = params => {
    var result = axios.post(`/api/CRCProject/ExportPMExeAmountReport`, params);
    return result;
}
export const GetPMWorkTimeReport = params => {
    var result = axios.post(`/api/CRCProject/GetPMWorkTimeReport`, params);
    return result;
}
export const ExportPMWorkTimeReport = params => {
    var result = axios.post(`/api/CRCProject/ExportPMWorkTimeReport`, params);
    return result;
}
export const ExportPMWorkSaturationReport = params => {
    var result = axios.post(`/api/CRCProject/ExportPMWorkSaturationReport`, params);
    return result;
}
export const GetQCMgrTotalReport = params => {
    var result = axios.post(`/api/CRCProject/GetQCMgrTotalReport`, params);
    return result;
}
export const ExportQCMgrTotalReport = params => {
    var result = axios.post(`/api/CRCProject/ExportQCMgrTotalReport`, params);
    return result;
}
//  批量导入项目合同工时数据
export const ImportProjectMtyCTimesData = params => {
    var result = axios.post(`/api/CRCProject/ImportProjectMtyCTimesData`, params);
    return result;
}
//  批量导出项目合同工时数据
export const ExportProjectMtyCTimesData = params => {
    var result = axios.post(`/api/CRCProject/ExportProjectMtyCTimesData`, params);
    return result;
}
//  获取项目合同工时数据列表
export const GetProjectMtyCTimesList = params => {
    var result = axios.post(`/api/CRCProject/GetProjectMtyCTimesList`, params);
    return result;
}
//  新增编辑项目合同工时
export const SetProjectMtyCTimes = params => {
    var result = axios.post(`/api/CRCProject/SetProjectMtyCTimes`, params);
    return result;
}

export const GetCRCMthPatientsList = params => {
    var result = axios.post(`/api/CRCProject/GetCRCMthPatientsList`, params);
    return result;
}
export const SetCRCMthPatients = params => {
    var result = axios.post(`/api/CRCProject/SetCRCMthPatients`, params);
    return result;
}

// 获取表格数据
export const GetYPINStorageList = params => {
    var result = axios.post(`/api/CRCProject/GetYPINStorageList`, params);
    return result;
}
// 设置表格数据
export const SetYPINStorage = params => {
    var result = axios.post(`/api/CRCProject/SetYPINStorage`, params);
    return result;
}

//样本导出
export const ExportYPINStorageList = params => {
    var result = axios.post(`/api/CRCProject/ExportYPINStorageList`, params);
    return result;
}

// 删除表格数据
export const DelYPINStorages = params => {
    var result = axios.post(`/api/CRCProject/DelYPINStorages?ids=${params}`);
    return result;
}
// 删除样本节点
export const DelYPINStorageNode = params => {
    var result = axios.post(`/api/CRCProject/DelYPINStorageNode?nodename=${params}&type=1`);
    return result;
}
// 获取项目管理项目列表
export const GetProjectListWeb = params => {
    var result = axios.post(`/api/CRCProject/GetProjectListWeb`, params);
    return result;
}
// 获取项目管理项目列表
export const GetWorkListWeb = params => {
    var result = axios.post(`/api/CRCProject/GetWorkListWeb`, params);
    return result;
}
export const GetPMWorkSaturationList = params => {
    var result = axios.post(`/api/CRCProject/GetPMWorkSaturationList`, params);
    return result;
}
//  导出PM执行额维护
export const ExportProjectMtyCTimesList = params => {
    var result = axios.post(`/api/CRCProject/ExportProjectMtyCTimesList`, params);
    return result;
}


// WEBPACK FOOTER //
// ./src/api/api.js